import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'indexCalendar',
  setup(__props) {

const Card8 = defineAsyncComponent(() => import("@/components/commen/card/cardData8.vue"))
const calenderView = defineAsyncComponent(() => import("@/components/theme/calender/calenderView.vue"))

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Apps",
      title: "Calendar"
    }),
    _createVNode(_unref(Card8), { colClass: "container-fluid calendar-basic" }, {
      default: _withCtx(() => [
        _createVNode(_unref(calenderView))
      ]),
      _: 1
    })
  ], 64))
}
}

})